import {
  GUIDED_SELLING_QUESTION1,
  GUIDED_SELLING_QUESTION2,
  GUIDED_SELLING_QUESTION3
} from "../../config/tags";
import { PREMIUM_PRODUCT, CORE_PRODUCT } from "./constants";

export const resultsFunction = (answers, questions) => {
  const gsQuestion1 = questions.find(q =>
    q.tags.includes(GUIDED_SELLING_QUESTION1)
  );
  const gsAnswer1 = answers.find(a => a.questionId === gsQuestion1._id);

  const gsQuestion2 = questions.find(q =>
    q.tags.includes(GUIDED_SELLING_QUESTION2)
  );
  const gsAnswer2 = answers.find(a => a.questionId === gsQuestion2._id);

  const gsQuestion3 = questions.find(q =>
    q.tags.includes(GUIDED_SELLING_QUESTION3)
  );
  const gsAnswer3 = answers.find(a => a.questionId === gsQuestion3._id);

  const firstAnswer = gsAnswer1.answers[0].value;
  const secondAnswer = gsAnswer2.answers[0].value;
  const thirdAnswer = gsAnswer3.answers[0].value;

  const answer = `${firstAnswer},${secondAnswer},${thirdAnswer}`;

  switch (answer) {
    case "C,C,D":
    case "W,W,W":
    case "W,W,C":
    case "W,W,D":
    case "C,W,W":
    case "C,W,C":
    case "C,W,D":
    case "C,C,W":
    case "C,C,C":
    case "D,W,C":
      return PREMIUM_PRODUCT;
    // Core cases:
    default:
      return CORE_PRODUCT;
  }
};

export const isPremiumOrCoaching = (answers, questions) => {
  const result = resultsFunction(answers, questions);

  if (result === PREMIUM_PRODUCT) {
    return true;
  }

  return false;
};
